import { c as _c } from "react/compiler-runtime";
import { Box, chakra, IconButton } from '@chakra-ui/react';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { MdClose } from 'react-icons/md';
import { Element, Transforms } from 'slate';
import { ReactEditor, RenderElementProps, useSlateStatic } from 'slate-react';
export interface RawMarkdownElementType extends Element {
  type: 'raw_markdown';
  source: string;
  inline?: boolean;
}
type RawMarkdownElementProps = RenderElementProps & {
  element: RawMarkdownElementType;
};

/**
 * Markdown the editor can't edit (an HTML embed, a table, a `sco-*` tag), kept byte for byte.
 * A block shows as it renders in the bubble, read-only, with a remove button; an inline piece
 * shows its source.
 */
export function RawMarkdownElement(props) {
  const $ = _c(17);
  const editor = useSlateStatic() as ReactEditor;
  if (props.element.inline) {
    let t0;
    if ($[0] !== props.attributes || $[1] !== props.children || $[2] !== props.element.source) {
      t0 = <chakra.span {...props.attributes} bg="bg.muted" borderRadius="sm" color="fg.muted" contentEditable={false} fontFamily="mono" fontSize="0.85em" paddingX={1}>{props.element.source}{props.children}</chakra.span>;
      $[0] = props.attributes;
      $[1] = props.children;
      $[2] = props.element.source;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let t0;
  if ($[4] !== editor || $[5] !== props.element) {
    t0 = () => {
      Transforms.removeNodes(editor, {
        at: ReactEditor.findPath(editor, props.element)
      });
    };
    $[4] = editor;
    $[5] = props.element;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const remove = t0;
  let t1;
  if ($[7] !== props.element.source) {
    t1 = <MarkdownRenderer>{props.element.source}</MarkdownRenderer>;
    $[7] = props.element.source;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MdClose />;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== remove) {
    t3 = <IconButton aria-label="Remove" position="absolute" right={1} size="2xs" top={1} variant="ghost" onClick={remove}>{t2}</IconButton>;
    $[10] = remove;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props.attributes || $[13] !== props.children || $[14] !== t1 || $[15] !== t3) {
    t4 = <Box {...props.attributes} borderColor="border.emphasized" borderRadius="md" borderStyle="dashed" borderWidth="1px" contentEditable={false} marginY={2} paddingLeft={3} paddingRight={8} paddingY={2} position="relative" whiteSpace="normal">{t1}{t3}{props.children}</Box>;
    $[12] = props.attributes;
    $[13] = props.children;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}